import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function NewsletterForm({ variant = "block" }) {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", msg: "" });
    try {
      const { data } = await api.post("/newsletter/subscribe", { first_name: firstName, email });
      setStatus({ state: "done", msg: data.message });
      setFirstName(""); setEmail("");
    } catch (err) {
      setStatus({ state: "error", msg: formatApiError(err.response?.data?.detail) });
    }
  };

  if (status.state === "done") {
    return (
      <div data-testid="newsletter-success" className="border border-primary/40 bg-primary/5 px-5 py-4">
        <div className="flex items-center gap-3">
          <Check className="h-5 w-5 text-primary shrink-0" />
          <p className="text-sm text-foreground/90">{status.msg}</p>
        </div>
        <a href="/resources/quick-start-checklist" data-testid="newsletter-checklist-link"
          className="mt-3 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-primary hover:gap-3 transition-all">
          Open your free Quick-Start Checklist <ArrowRight className="h-3.5 w-3.5" />
        </a>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="w-full">
      <div className={`flex flex-col ${variant === "inline" ? "sm:flex-row" : ""} gap-3`}>
        <input
          data-testid="newsletter-first-name"
          required value={firstName} onChange={(e) => setFirstName(e.target.value)}
          placeholder="First name"
          className="flex-1 bg-surface border border-border px-4 py-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none transition-colors"
        />
        <input
          data-testid="newsletter-email"
          required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Email address"
          className="flex-1 bg-surface border border-border px-4 py-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none transition-colors"
        />
        <button
          data-testid="newsletter-submit"
          disabled={status.state === "loading"}
          className="group inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground font-medium text-sm px-6 py-3 hover:bg-primary-hover transition-colors disabled:opacity-60 shadow-[0_0_15px_rgba(0,229,153,0.25)]"
        >
          {status.state === "loading" ? "Sending…" : "Get the Free Checklist"}
          <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
      {status.state === "error" && (
        <p data-testid="newsletter-error" className="mt-2 text-xs text-destructive">{status.msg}</p>
      )}
      <p className="mt-4 text-xs text-muted-foreground leading-relaxed">
        We'll email your free <span className="text-foreground/80">Low-Tox Quick-Start Checklist</span> right away, then send each
        new Greenpaper as it's published. We never sell your information. Unsubscribe anytime.
      </p>
    </form>
  );
}
